export const capWord = (word: string) => {
  const firstLetter = word[0]
  return `${firstLetter.toUpperCase()}${word.substring(1)}`
}